import calenderIcon from "../../assets/img/calenderIcon.svg"; 
import csvIcon from "../../assets/img/csvicon.svg";           
import DownloadIcon from "../../assets/img/downloadIcon.svg"; 
import pdfIcon from "../../assets/img/pdficon.svg";          
import xlsIcon from "../../assets/img/xlsicon.svg";          
import { useTranslation } from "react-i18next";
import { FaArrowLeft } from "react-icons/fa6";
import CustomSelect from "./CustomSelect";

const CommonHeader = ({
  name,
  fileType,
  handleFileTypeChange,
  downloadContent,
  filterData,
  discardedFileType,
  customChildren,
  children,
  timeSeperator,
  onBack,
}) => {
  const { t } = useTranslation("common");
  let downloadTypes = [
    { value: "csv", label: "CSV", image: csvIcon },
    { value: "pdf", label: "PDF", image: pdfIcon },
    { value: "xlsx", label: "XLSX", image: xlsIcon },
  ].filter((k) => discardedFileType?.[k.value] === undefined);

  let keepDownload =
    fileType && handleFileTypeChange && downloadContent && downloadTypes;

  let childLength =
    typeof children === "undefined"
      ? 1
      : typeof children === "object"
      ? 2
      : children.length + 1;

  return (
    <div className="commonHeader | mb-3">
      {onBack && (
        <button
          type="button"
          className="btn dwn-btn-border bg-white"
          onClick={onBack}
          title={t("back", { defaultValue: "Back" })}
        >
          <FaArrowLeft />
          <span className="d-none d-sm-inline">
            {t("back", { defaultValue: "Back" })}
          </span>
        </button>
      )}
      <p>{name}</p>
      <div
        className="d-flex gap-2 align-items-center"
        style={{
          "--dropdownWidth": Math.ceil(100 / childLength) - 2 + "%",
        }}
      >
        {children && children}

        {filterData && filterData.startDate && filterData.endDate && (
          <div className="filteredDate d-flex gap-1 dwn-btn-border align-items-center bg-white">
            <img
              src={calenderIcon}
              loading="lazy"
              className="d-none d-sm-block"
            />
            <p className="mb-0 fw-500 d-none d-md-block fs-14">
              {t("dateLabel", { defaultValue: "Date:" })}
            </p>
            <p className="mb-0 text-gray px-1 px-md-2 fs-14">
              {
                filterData.startDate
                  .split(timeSeperator ?? " ")[0]
                  .split("-")
                  .reverse()
                  .join("-") +
                  (!timeSeperator
                    ? ""
                    : " " + filterData.startDate.split(timeSeperator)[1])
              }
            </p>
            <p className="mb-0 fw-500 d-none d-md-block fs-14">
              {t("toLabel", { defaultValue: "to" })}
            </p>
            <p className="mb-0 fw-500 d-block d-md-none fs-14">-</p>
            <p className="mb-0 text-gray ps-1 ps-md-2 fs-14">
              {
                filterData.endDate
                  .split(timeSeperator ?? " ")[0]
                  .split("-")
                  .reverse()
                  .join("-") +
                  (!timeSeperator
                    ? ""
                    : " " + filterData.endDate.split(timeSeperator)[1])
              }
            </p>
          </div>
        )}

        {keepDownload && (
          <div className="dropdown">
            <div className="d-flex dwn-btn-border align-items-center bg-white">
              <div
                style={{
                  position: "relative",
                  zIndex: 5,
                  borderRight: "1px solid #b5b5b5",
                }}
              >
                <CustomSelect
                  selectData={{
                    fileType,
                    handleFileTypeChange,
                    downloadTypes,
                  }}
                />
              </div>
              <button
                type="button"
                className="btn dwn-btn"
                onClick={downloadContent}
              >
                <span>{t("download", { defaultValue: "Download" })}</span>
                <img
                  src={DownloadIcon}
                  alt=""
                  loading="lazy"
                  className="ms-2"
                />
              </button>
            </div>
          </div>
        )}

        {customChildren && customChildren}
      </div>
    </div>
  );
};

export default CommonHeader;
